// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Apercu du catalogue rendu DANS LA PAGE, au pixel pres comme la modale (les lignes utilisent les
   classes .article-row/.article-* de ModalArticles.css). Ce fichier ne porte QUE le cadre cliquable,
   l'en-tete, le pied, et la neutralisation des controles internes. Palette : orange #f97316. */
.catalogue-preview {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  /* Dezoom global : mini-replicat de la modale (les lignes gardent leurs proportions exactes, en
     plus compact). \`zoom\` reflow proprement, sans espace mort d'un transform: scale. */
  zoom: 0.8;
}
.catalogue-preview:hover,
.catalogue-preview:focus-visible {
  border-color: #f97316;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);
  outline: none;
}

/* En-tete facon modale. */
.catalogue-preview__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 2rem;
  border-bottom: 1px solid #e5e7eb;
}
.catalogue-preview__titre {
  color: #2c3948;
  font-size: 1.8rem;
  font-weight: 600;
}
.catalogue-preview__cta {
  color: #f97316;
  font-size: 1.3rem;
  font-weight: 600;
}

/* Les lignes sont celles de la modale ; on neutralise toute interaction pour que le clic remonte
   au cadre (qui ouvre la vraie modale). Les controles restent visibles a l'identique. */
.catalogue-preview .articles-list,
.catalogue-preview .article-row,
.catalogue-preview .quantity-controls,
.catalogue-preview .quantity-input,
.catalogue-preview .quantity-btn,
.catalogue-preview .button {
  pointer-events: none;
}

/* Pied "voir tout" (affordance vers la modale complete). */
.catalogue-preview__more {
  padding: 1.4rem 2rem;
  color: #f97316;
  font-size: 1.3rem;
  font-weight: 500;
  text-align: center;
  background: #fff;
}

.catalogue-preview__loading,
.catalogue-preview__vide {
  color: #6b7280;
  font-size: 1.4rem;
  padding: 2rem;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/composants/CataloguePreview/CataloguePreview.css"],"names":[],"mappings":"AAAA;;+FAE+F;AAC/F;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0DAA0D;EAC1D;uFACqF;EACrF,SAAS;AACX;AACA;;EAEE,qBAAqB;EACrB,8CAA8C;EAC9C,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;wFACwF;AACxF;;;;;;EAME,oBAAoB;AACtB;;AAEA,2DAA2D;AAC3D;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB","sourcesContent":["/* Apercu du catalogue rendu DANS LA PAGE, au pixel pres comme la modale (les lignes utilisent les\n   classes .article-row/.article-* de ModalArticles.css). Ce fichier ne porte QUE le cadre cliquable,\n   l'en-tete, le pied, et la neutralisation des controles internes. Palette : orange #f97316. */\n.catalogue-preview {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  cursor: pointer;\n  overflow: hidden;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  /* Dezoom global : mini-replicat de la modale (les lignes gardent leurs proportions exactes, en\n     plus compact). `zoom` reflow proprement, sans espace mort d'un transform: scale. */\n  zoom: 0.8;\n}\n.catalogue-preview:hover,\n.catalogue-preview:focus-visible {\n  border-color: #f97316;\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);\n  outline: none;\n}\n\n/* En-tete facon modale. */\n.catalogue-preview__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 2rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n.catalogue-preview__titre {\n  color: #2c3948;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n.catalogue-preview__cta {\n  color: #f97316;\n  font-size: 1.3rem;\n  font-weight: 600;\n}\n\n/* Les lignes sont celles de la modale ; on neutralise toute interaction pour que le clic remonte\n   au cadre (qui ouvre la vraie modale). Les controles restent visibles a l'identique. */\n.catalogue-preview .articles-list,\n.catalogue-preview .article-row,\n.catalogue-preview .quantity-controls,\n.catalogue-preview .quantity-input,\n.catalogue-preview .quantity-btn,\n.catalogue-preview .button {\n  pointer-events: none;\n}\n\n/* Pied \"voir tout\" (affordance vers la modale complete). */\n.catalogue-preview__more {\n  padding: 1.4rem 2rem;\n  color: #f97316;\n  font-size: 1.3rem;\n  font-weight: 500;\n  text-align: center;\n  background: #fff;\n}\n\n.catalogue-preview__loading,\n.catalogue-preview__vide {\n  color: #6b7280;\n  font-size: 1.4rem;\n  padding: 2rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
